import React, { useState, useEffect } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";

// Función para ajuste decimal
const decimalAdjust = (type, value, exp) => {
  if (exp === undefined || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
};

const EditableCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  updateData,
}) => {
  const [value, setValue] = useState(initialValue);

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onBlur = () => {
    updateData(index, id, value);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <input
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      style={{ width: "100%", border: "none", textAlign: "right" }}
    />
  );
};

const datosProveedores = [
  {
    IdDetalleMovimientosAlmacen: 1,
    NombreProductoConPresentacion: "Laptop Dell XPS 13 - 512GB SSD",
    Cantidad: 5,
    Porcentaje: "15%",
    costo: 1250.00,
    venta: 1437.50,
    bonificado: 120.0,
  },
  {
    IdDetalleMovimientosAlmacen: 2,
    NombreProductoConPresentacion: "Monitor Samsung 24\" Curvo",
    Cantidad: 8,
    Porcentaje: "20%",
    costo: 180.00,
    venta: 216.00,
    bonificado: 0,
  },
  {
    IdDetalleMovimientosAlmacen: 3,
    NombreProductoConPresentacion: "Teclado Mecánico RGB",
    Cantidad: 12,
    Porcentaje: "25%",
    costo: 75.00,
    venta: 93.75,
    bonificado: 0,
  },
  {
    IdDetalleMovimientosAlmacen: 4,
    NombreProductoConPresentacion: "Mouse Inalámbrico Logitech",
    Cantidad: 15,
    Porcentaje: "30%",
    costo: 45.00,
    venta: 58.50,
    bonificado: 5,
  },
  {
    IdDetalleMovimientosAlmacen: 5,
    NombreProductoConPresentacion: "Impresora HP LaserJet",
    Cantidad: 3,
    Porcentaje: "18%",
    costo: 320.00,
    venta: 377.60,
    bonificado: 50.0,
  }
].map(item => ({
  ...item,
  Total: item.Cantidad * item.costo,
  utilidad: (item.venta - item.costo) * item.Cantidad
}));

function TablaProveedores(props) {
  const [rows, setRows] = useState([]);

  const updateData = (index, id, value) => {
    const newValue = parseFloat(value) || 0;
    
    setRows(prev => {
      const newData = [...prev];
      
      if (!newData[index]) return prev;
      
      newData[index] = {
        ...newData[index],
        [id]: newValue,
      };
      
      const cantidad = newData[index].Cantidad || 0;
      const costo = newData[index].costo || 0;
      const venta = newData[index].venta || 0;
      
      newData[index] = {
        ...newData[index],
        Total: cantidad * costo,
        utilidad: (venta - costo) * cantidad
      };
      
      return newData;
    });
  };

  useEffect(() => {
    let data = props.data && props.data.length > 0 ? props.data : datosProveedores;
    
    if (props.data && props.data.length > 0) {
      data = props.data.map(item => ({
        ...item,
        Cantidad: item.Cantidad || 0,
        costo: item.costo || 0,
        venta: item.venta || 0,
        Total: (item.Cantidad || 0) * (item.costo || 0),
        utilidad: ((item.venta || 0) - (item.costo || 0)) * (item.Cantidad || 0)
      }));
    }
    
    setRows(data.sort((a, b) => (a.IdDetalleMovimientosAlmacen < b.IdDetalleMovimientosAlmacen) ? 1 : -1));
  }, [props.data]);

  const columns = [
    {
      Header: "Producto",
      accessor: "NombreProductoConPresentacion",
      minWidth: 215
    },
    {
      Header: "Cantidad",
      accessor: "Cantidad",
      maxWidth: 100,
      Cell: props => <EditableCell {...props} updateData={updateData} />
    },
    {
      Header: "Porcentaje",
      accessor: "Porcentaje",
      maxWidth: 100,
      Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>
    },
    {
      Header: "P. COSTO",
      accessor: "costo",
      maxWidth: 100,
      Cell: props => <EditableCell {...props} updateData={updateData} />
    },
    {
      Header: "P. VENTA",
      accessor: "venta",
      maxWidth: 100,
      Cell: props => <EditableCell {...props} updateData={updateData} />
    },
    {
      Header: "Bonificado",
      accessor: "bonificado",
      maxWidth: 100,
      Cell: row => <div style={{textAlign: "right"}}>{row.value}</div>
    },
    {
      Header: "Total",
      accessor: "Total",
      maxWidth: 100,
      Cell: row => <div style={{textAlign: "right"}}>{decimalAdjust('floor', row.value, -2)}</div>
    },
    {
      Header: "U. BRUTA",
      accessor: "utilidad",
      maxWidth: 100,
      Cell: row => <div style={{textAlign: "right"}}>{decimalAdjust('floor', row.value, -2)}</div>
    }
  ];

  
  return (
    <ReactTable
      data={rows}
      disabled={false}
      columns={columns}
      defaultPageSize={5}
      showPagination={true}
      style={{
        height: "400px",
        width: "100%",
        fontSize: "13px"
      }}
      className="-striped -highlight"
    />
  );
}

export default TablaProveedores;